export default __webpack_public_path__ + "static/67463-5efdb2c184744dbdb5ce273a5c2fdf07.jpg";